import { IMAGES } from 'src/assets'

export const MEDALS = {
  1: IMAGES.MEDAL_1ST,
  2: IMAGES.MEDAL_2ND,
  3: IMAGES.MEDAL_3RD
}
